/**
 * User API Service
 * Migrated from 3in1cms legacy/userApi.ts
 */

import { request } from "../core/request";
import { API_RESPONSE_CODES, OPERATION_IDS } from "./constants";

interface IMobileHashResData {
  statusCode: string;
  mobileHash: string;
}

/**
 * Get hash code by mobile number
 * @param mobileNo - Mobile number
 * @returns Mobile number hash code or empty string
 */
export const getHashCodeByMobileNo = async (mobileNo: string): Promise<string> => {
  try {
    const response = (await request<IMobileHashResData, { mobileNumber: string }>({
      operationId: OPERATION_IDS.getHashCode,
      requestData: {
        mobileNumber: mobileNo,
      },
    })) as IMobileHashResData;

    if (response.statusCode === API_RESPONSE_CODES.STATUS_CODE_7001) {
      return response.mobileHash;
    }
    return "";
  } catch (error) {
    console.error("Error in getHashCodeByMobileNo", error);
    return "";
  }
};
